import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { initialState } from './state';
import { setUserToken } from './actions';

export const reducer = reducerWithInitialState(initialState).case(
    setUserToken,
    (state, payload) => ({
        ...state,
        token: payload,
    }),
);

export default reducer;
